var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({staticClass:"svg-icon",style:(_vm.containerStyle),domProps:{"innerHTML":_vm._s(_vm.processedSvg)}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }